/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import Header from "../../Header";
import Sidebar from "../../Sidebar";
import { Link } from "react-router-dom";
// import { Table } from "antd";
// import { itemRender, onShowSizeChange } from "../../Pagination";
import { imagesend } from "../../imagepath";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TableCell,
  Paper,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from "@mui/material";

// function DeleteRow (props)
//  {

//   const {open, }
//   function handleClose() {

//   }
//   return(

//   )

//  }
const AppointmentPatient = (props) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const onSelectChange = (newSelectedRowKeys) => {
    // console.log("selectedRowKeys changed: ", selectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const tableData = [
    {
      id: "1",
      Doctor_Name: "Dr. Smith Khurana",
      Treatment: "Cancer",
      Form_Date: "03-2-2024",
      end_Date: "05-2-2024",
      status: "Active",
      FIELD9: "",
    },
    {
      id: "2",
      Doctor_Name: "Dr. Smith Khurana",
      Treatment: "Cancer",
      Form_Date: "03-2-2024",
      end_Date: "05-2-2024",
      status: "Active",
      FIELD9: "",
    },
    {
      id: "3",
      Doctor_Name: "Dr. Smith Khurana",
      Treatment: "Cancer",
      Form_Date: "03-2-2024",
      end_Date: "05-2-2024",
      status: "Active",
      FIELD9: "",
    },
    {
      id: "4",
      Doctor_Name: "Dr. Smith Khurana",
      Treatment: "Cancer",
      Form_Date: "03-2-2024",
      end_Date: "05-2-2024",
      status: "Active",
      FIELD9: "",
    },
  ];
  const column = [
    {
      headerName: "Doctor Name",
      field: "Doctor_Name",
      width: 200,
      render: (text, record) => (
        <>
          <Link to="#">{record.Doctor_Name}</Link>
        </>
      ),
    },
    {
      headerName: "Treatment",
      field: "Treatment",
      width: 200,
      sorter: (a, b) => a.Treatment.length - b.Treatment.length,
    },
    {
      headerName: "Form Date",
      field: "Form_Date",
      width: 150,
      sorter: (a, b) => a.Form_Date.length - b.Form_Date.length,
    },
    {
      headerName: "End Date",
      field: "end_Date",
      width: 150,
      sorter: (a, b) => a.end_Date.length - b.end_Date.lenght,
    },
    {
      headerName: "Status",
      field: "status",
      width: 150,
      sorter: (a, b) => a.status.length - b.status.length,
    },
    {
      headerName: "Action",
      width: 200,
      renderCell: (params) => (
        <Box sx={{ minWidth: 50 }}>
          <Button>
              <i className="far fa-edit me-2" />
              Edit
          </Button>
          <Button>
            <Link to="#" onClick={handleOpen}>
              <i className="fa fa-trash-alt m-r-5"></i> Delete
            </Link>
          </Button>
          
        </Box>
      ),
    },
  ];

  return (
    <>
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-6">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="index.html">Dashboard </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">Appointment</li>
                </ul>
              </div>
              <div className="col-sm-5 col-6 text-end m-b-30">
                  <Button>
                    <i className="fa fa-plus" />
                    Add Appointment
                  </Button>
              </div>
            </div>
          </div>

          {/*appointment table data*/}

          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body">
                  <div>
                    <Box className="table-responsive doctor-list">
                      <DataGrid
                        columns={column}
                        rows={tableData}
                        rowSelection={rowSelection}
                        rowKey={(record) => record.id}
                        // pageSizeOptions={[9]}
                        checkboxSelection
                        disableRowSelectionOnClick
                      />
                    </Box>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Dialog open={open} onClose={handleClose}>
            <DialogTitle className="modal-body text-center">
              <img src={imagesend} alt="#" width={50} height={46} />
              Are you sure want to delete this ?
            </DialogTitle>
            <DialogContent></DialogContent>
            <DialogActions >
              <Button onClick={handleClose} variant="contained"  >
                Delete
              </Button>
              <Button onClick={handleClose} variant="outlined" >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>

      {/* <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-body text-center">
          <img src={imagesend}alt="#" width={50} height={46} />
          <h3>Are you sure want to delete this ?</h3>
          <div className="m-t-20">
            {" "}
           <Link to="#" className="btn btn-white me-2" data-bs-dismiss="modal">
              Close
            </Link>
            <button type="submit" className="btn btn-danger">
              Delete
            </button>
          </div>
        </div>
      </div>
      </div> */}
    </>
  );
};

export default AppointmentPatient;
